import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.salaryRange.replaced',
    subtitle: 'pages.onboarding.salaryRange.replacedSub',
    value: 'replaced',
  },
  {
    title: 'pages.onboarding.salaryRange.fallingBehind',
    subtitle: 'pages.onboarding.salaryRange.fallingBehindSub',
    value: 'falling-behind',
  },
  {
    title: 'pages.onboarding.salaryRange.industryChange',
    subtitle: 'pages.onboarding.salaryRange.industryChangeSub',
    value: 'industry-change',
  },
  {
    title: 'pages.onboarding.salaryRange.blindSpots',
    subtitle: 'pages.onboarding.salaryRange.blindSpotsSub',
    value: 'blind-spots',
  },
  {
    title: 'pages.onboarding.salaryRange.nothing',
    subtitle: 'pages.onboarding.salaryRange.nothingSub',
    value: 'nothing',
  },
]

export default function SalaryRangePage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.salaryRange.title"
    />
  )
}
